import type { BillingCycle } from '@weft/types';
import type { BillingCycleInput } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import React, { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import type { MenuItem } from '../../../components/design/menu';
import { Menu } from '../../../components/design/menu';
import { EditIcon, PlaneIcon } from '../../../components/icons';
import { DeactivateIcon } from '../../../components/icons/DeactivateIcon';
import { TrashIcon } from '../../../components/icons/TrashIcon';
import { useUpdateBillingCycle } from '../../../hooks/requests/use-update-billing-cycle';
import { AddEditBillingCycleDialog } from './AddEditBillingCycleDialog';

type BillingCycleDotMenuProps = {
  billingCycle: BillingCycle;
};

type MenuActions = {
  onEdit: () => void;
};

export const BillingCycleOverviewDotMenu:React.FC<BillingCycleDotMenuProps> = ({
  billingCycle,
}) => {
  const [billingCycleDialogOpen, setBillingCycleDialogOpen] = useState<boolean>(false);
  const formContext = useFormContext<BillingCycleInput>();
  const { mutate: updateBillingCycleMutation } = useUpdateBillingCycle();

  const swallowClick = (e:React.MouseEvent) => {
    e.stopPropagation();
  };

  const onBillingCycleEdit = useCallback(() => {
    formContext.reset(billingCycle);
    setBillingCycleDialogOpen(true);
  }, [billingCycle, formContext]);

  const updateBillingCycle = (updateBillingCycleRequest: BillingCycleInput, onSuccess?: () => void) => {
    if (isNotNullOrUndefined(updateBillingCycleRequest)) {      
      updateBillingCycleMutation({ billingCycleId: billingCycle.id, updateBillingCycleRequest }, {
        onSuccess,
      });
    }
  };

  return (
    <div onClick={swallowClick}>
      <Menu
        align="left"
        menuItems={getMenuItems({
          onEdit: onBillingCycleEdit,
        })}
        className="mx-4 w-auto whitespace-nowrap"
        wrapperClassName="ml-auto"
      >
        <span
          className='bg-icon text-label mx-2 mb-[3px] inline-block h-1 w-1 rounded-[50%] shadow-[0_7px_0_#ADC2E2,0_-7px_0_#ADC2E2]'
        ></span>
      </Menu>
      <AddEditBillingCycleDialog
        open={billingCycleDialogOpen}
        onClose={() => setBillingCycleDialogOpen(false)}
        onSubmit={updateBillingCycle}
      />
    </div>
  );
};

const getMenuItems = (menuActions: MenuActions, isActivated = true): MenuItem[] => ([
  {
    id: 1,
    icon: isActivated ?
      <DeactivateIcon
        width='22'
        height='22'
      /> : <PlaneIcon/>,
    label: isActivated ? 'Deactivate' : 'Activate',
  },
  {
    id: 2,
    icon: <EditIcon
      color="#458FFF"
      width='22'
      height='22'
    />,
    label: 'Edit',
    onClick: menuActions.onEdit,
  },
  {
    id: 3,
    icon: <TrashIcon color="#458FFF" />,
    label: 'Delete',
  },
]);